import { Trans } from '@donaswap/localization'

export default Trans
